import HttpRequest from "@/store/axios";
import config from "@/config/config";

const apiWeb = new HttpRequest(
	process.env.NODE_ENV === "development"
		? config.apiUrl.dev
		: config.apiUrl.pro
);

export default {
	mutations: {},
	getters: {},
	actions: {
		web_index({ commit }, data) {
			return apiWeb.apiRequest(data, "index-index.html", "post");
		},
		web_footer({ commit }, data) {
			return apiWeb.apiRequest(data, "index-footer.html", "post");
		},
		web_contactUs({ commit }, data) {
			return apiWeb.apiRequest(data, "index-contactUs.html", "post");
		},
		web_education({ commit }, data) {
			return apiWeb.apiRequest(data, "index-education.html", "post");
		},
		web_notice({ commit }, data) {
			return apiWeb.apiRequest(data, "index-notice.html", "post");
		},
		web_product({ commit }, data) {
			return apiWeb.apiRequest(data, "index-product.html", "post");
		},
		web_about({ commit }, data) {
			return apiWeb.apiRequest(data, "index-about.html", "post");
		},
		web_proFocus({ commit }, data) {
			return apiWeb.apiRequest(data, "index-proFocus.html", "post");
		},
		web_getDataList({ commit }, data) {
			return apiWeb.apiRequest(data, "index-getDataList.html", "post");
		},
		web_getDataInfo({ commit }, data) {
			return apiWeb.apiRequest(data, "index-getDataInfo.html", "post");
		},
	},
};
